import { navigationItems } from "../../data/navigation/navigation";
import { Icon } from "../common/Icon";
import type { Locale } from "../../types/app";

export function Footer({ locale }: { readonly locale: Locale }) {
  const isArabic = locale === "ar";
  const currentYear = new Date().getFullYear();
  const footerLinks = navigationItems.filter((item) => ["#/", "#/athkar", "#/quran", "#/prayer", "#/qibla", "#/moon", "#/favorites", "#/manasik", "#/alkhalili", "#/donate", "#/about"].includes(item.href));

  return (
    <footer className="footer" dir={isArabic ? "rtl" : "ltr"}>
      <div className="container footer__inner">
        <div className="footer__top">
          <a className="footer__brand" href="#/" aria-label={isArabic ? "العودة إلى الرئيسية" : "Back to home"}>
            <img className="footer__logo-mark" src="/assets/icons/athkari-logo.svg" alt="" />
            <span>
              <strong className="sr-only">أذكاري</strong>
              <img className="footer__wordmark" src="/assets/icons/athkari-wordmark.svg" alt="" />
              <small>{isArabic ? "أذكار وقرآن وعبادات يومية" : "Athkar, Quran, and daily worship"}</small>
            </span>
          </a>

          <p className="footer__summary">
            {isArabic
              ? "تجربة هادئة وسريعة تحفظ وردك ومفضلتك على جهازك."
              : "A calm, fast experience that keeps your daily progress on your device."}
          </p>

          <div className="footer__external" aria-label={isArabic ? "روابط خارجية" : "External links"}>
            <a href="https://athkari.cc" target="_blank" rel="noopener noreferrer">
              <span>athkari.cc</span>
              <Icon name="arrow-up-right" />
            </a>
            <a href="https://issamawali.com" target="_blank" rel="noopener noreferrer">
              <span>issamawali.com</span>
              <Icon name="arrow-up-right" />
            </a>
          </div>
        </div>

        <nav className="footer__nav" aria-label={isArabic ? "روابط التذييل" : "Footer navigation"}>
          {footerLinks.map((item) => (
            <a key={item.href} href={item.href}>
              <Icon name={item.icon} />
              <span>{isArabic ? item.labelAr : item.labelEn}</span>
            </a>
          ))}
          <a href="#/contact">
            <Icon name="message" />
            <span>{isArabic ? "تواصل" : "Contact"}</span>
          </a>
        </nav>

        <div className="footer__bottom">
          <span>{isArabic ? `© ${currentYear} أذكاري` : `© ${currentYear} Athkari`}</span>
          <span>{isArabic ? "صُمم وطُوّر بواسطة عيسى المعولي" : "Designed and built by Issa Al-Mawali"}</span>
        </div>
      </div>
    </footer>
  );
}
